import { DigitalShareAppType } from "../Enums/DigitalShareAppType";
import { DigitalShareItemType } from "../Enums/DigitalShareItemType";
import { RenderType } from "../Enums/RenderType";

export interface IVennChart {
  percent1: number;
  percent2: number;
  centralPercent: number;
  centralIcon: JSX.Element;
  location1Name: string;
  location2Name: string;
  isActive?: boolean;
}

export interface IVennCircleWrapper {
  mobileInitDiam: number;
  mobileExpDiam: number;
  desktopInitDiam: number;
  desktopExpDiam: number;
}

export interface IVennCircle {
  percent: number;
  mobileInitDiam: number;
  mobileExpDiam: number;
  desktopInitDiam: number;
  desktopExpDiam: number;
  backgroundColor: string;
}
